const WhiteCheckmark = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <circle cx="10" cy="10" r="10" fill="#F0F8F9" />
      <path
        d="M13.9395 7.28202L8.93941 12.907L6.43953 10.407"
        stroke="#03292E"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default WhiteCheckmark;
